<template>
    <v-layout wrap>
        <v-flex lg6 md12 pr-3>
            <v-form @submit.prevent="submit" v-model="formValid" ref="form">
                <v-layout style="min-height: 300px">
                    <v-flex xs12 md6 class="mx-1">
                        <v-text-field
                            :label="($t('selectImage') + ' 1')| capitalize"
                            @click="pickFile(true)"
                            v-model='image1.name'
                            prepend-inner-icon='attach_file'
                            :rules="formRules.required"
                        ></v-text-field>
                        <input
                            type="file"
                            style="display: none"
                            ref="image1"
                            accept="image/*"
                            @change="onFilePicked($event, true)"
                        >
                        <img v-if="image1.url" :src="image1.url" alt="image 1" class="data-img">
                    </v-flex>
                    <v-flex xs12 md6 class="mx-1">
                        <v-text-field
                            :label="($t('selectImage') + ' 2') | capitalize"
                            @click="pickFile(false)"
                            v-model='image2.name'
                            prepend-inner-icon='attach_file'
                            :rules="formRules.required"
                        ></v-text-field>
                        <input
                            type="file"
                            style="display: none"
                            ref="image2"
                            accept="image/*"
                            @change="onFilePicked($event, false)"
                        >
                        <img v-if="image2.url" :src="image2.url" alt="image 2" class="data-img">
                    </v-flex>
                </v-layout>
                <v-layout align-center class="mt-3">
                    <v-btn type="submit" color="primary">{{$t('check')}}</v-btn>
                    <div>
                        <table>
                            <tr>
                                <td>match</td>
                                <td>{{result.isMatch}}</td>
                            </tr>
                            <tr>
                                <td>similarity</td>
                                <td>{{result.similarity}} %</td>
                            </tr>
                        </table>
                    </div>
                </v-layout>
            </v-form>
        </v-flex>
        <v-flex lg6 md12 style="text-align: left">
            <h2 class="py-2">API</h2>
            <v-select
                label="API Key"
                v-model="apiKey"
                :items="listAPIKey"
                class="mt-3"
            ></v-select>
            <v-layout row reverse wrap align-center>
                <v-btn
                    @click="$utils.copyToClipboard(code[apiType], $t('copiedToClipboard', ['code']))"
                    title="copy key to clipboard"
                    class="ma-0"
                    depressed
                    color="info"
                >
                    <v-icon>file_copy</v-icon>
                    Copy
                </v-btn>
                <v-radio-group v-model="apiType" row>
                    <v-radio label="cUrl " value="curl"></v-radio>
                    <v-radio label="Python" value="python"></v-radio>
                </v-radio-group>
            </v-layout>
            <code>{{code[apiType]}}</code>
        </v-flex>
    </v-layout>
</template>
<script>

import { inject } from '@/utils/VariableInjection'
/* eslint-disable */
import fmPython from 'raw-loader!../code/fmPython.txt'
import fmCUrl from 'raw-loader!../code/fmCUrl.txt'
/* eslint-enable */
import axios from 'axios'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import ApiDemo from '@/views/APIs/demo/ApiDemo'

export default {
    name: 'FaceMatchDemo',
    extends: ApiDemo,
    mixins: [FormMixin],
    props: {
        parent: Object
    },
    data () {
        return {
            image1: {
                name: '',
                url: '',
                file: ''
            },
            image2: {
                name: '',
                url: '',
                file: ''
            },
            apiType: 'curl',
            demoUrl: process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_FACE_MATCH,
            result: {
                isMatch: false,
                similarity: 0
            }
        }
    },
    computed: {
        code () {
            let variableMap = {
                url: this.demoUrl,
                apiKey: this.apiKey,
                image1: this.image1.name,
                image2: this.image2.name
            }
            return {
                python: inject(fmPython, variableMap),
                curl: inject(fmCUrl, variableMap)
            }
        }
    },
    methods: {
        pickFile (isFirstImage = true) {
            if (isFirstImage) {
                this.$refs.image1.click()
            } else {
                this.$refs.image2.click()
            }
        },
        onFilePicked (input, isFirstImage = true) {
            let image = isFirstImage ? this.image1 : this.image2
            const file = input.target.files[0]
            if (file !== undefined) {
                if (file.name.lastIndexOf('.') <= 0) {
                    return
                }
                image.file = file
                image.name = file.name

                let reader = new FileReader()
                reader.onload = e => {
                    image.url = e.target.result
                }
                reader.readAsDataURL(file)
            }
        },
        submitValidForm () {
            let formData = new FormData()
            formData.append('file[]', this.image1.file)
            formData.append('file[]', this.image2.file)
            this.$appService.showLoading()
            axios.post(
                this.demoUrl,
                formData,
                {
                    headers: {
                        'api-key': this.apiKey,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(
                result => {
                    if (result.data.code === '200') {
                        this.result = result.data.data
                        this.parent.getRemain()
                    } else {
                        this.$appService.toastError(result.data.message)
                    }
                },
                this.$appService.handleRequestError(this.$t('error'))
            ).finally(this.$appService.hideLoading)
        }
    }
}
</script>
<style scoped>
    table tr td:first-child {
        font-weight: bold;
        padding: 0px 15px 0px 0;
    }

    table td {
        text-align: left;
    }

    code {
        padding: 5px;
        width: 100%;
    }

    code::before {
        content: "";
    }

    .data-img {
        max-width: 100%;
    }
</style>
